import { ModuleType } from "../module";
var buildContainer = function(key, modules) {
    var renderCondition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return {
        id: key,
        key: key,
        modules: modules,
        renderCondition: renderCondition,
        type: ModuleType.Container
    };
};
export { buildContainer };
